(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/wager-payment-flow/standard-flow/assets/javascripts/middlewares-setup.js') >= 0) return;  svs.modules.push('/components/wager-payment-flow/standard-flow/assets/javascripts/middlewares-setup.js'); "use strict";


const {
  dialog
} = svs.components;
const {
  Confirm
} = dialog;
const {
  accountBalance
} = svs.components.wager.middleware;
const accountBalanceMW = accountBalance(interactionContext => new Promise((resolve, reject) => {
  const {
    messages
  } = interactionContext;
  dialog.api.add(new Confirm({
    branding: svs.components.dialog.branding.SPORT,
    type: svs.components.dialog.type.DEFAULT,
    icon: 'balance',
    title: messages[0],
    message: [{
      type: svs.components.dialog.message.TEXT,
      text: [messages[1], messages[2]].join('<br />')
    }],
    actions: [{
      title: 'Avbryt',
      showLoader: true,
      callback() {
        svs.components.dialog.api.close();
        reject();
      }
    }, {
      title: 'Sätt in',
      showLoader: true,
      callback() {
        svs.components.dialog.api.close();
        resolve();
      }
    }]
  }));
}));
setGlobal('svs.components.wagerPaymentFlow.standardFlow.middlewareSetup', {
  accountBalanceMW
});
 })(window);